var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e71296ac-fd31-454b-9450-f77ad7a1690b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.48 26.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6ca2fb39-b700-41aa-b76c-2ca9216fd0bc {\n        fill: #009fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-e3cdc741-5645-4c77-8cfe-cc33fe09727d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6ca2fb39-b700-41aa-b76c-2ca9216fd0bc",
    d: "m5.95,5.06v12.32c0,.45-.4.77-.85.7-.95-.15-2,.01-3.08.64-.67.39-1.23.98-1.55,1.68-1.91,4.14,2.3,8.15,6.44,5.85,1.23-.69,1.98-2.02,1.98-3.43v-12.03c0-.46.32-.85.77-.93l9.99-1.96c.46-.09.89.26.89.73v4.81c0,.45-.4.77-.85.7-.95-.15-2,.01-3.08.64-.67.39-1.23.98-1.55,1.68-1.9,4.14,2.3,8.15,6.44,5.85,1.23-.69,1.98-2.02,1.98-3.43V2.67c0-1.68-1.53-2.94-3.18-2.61l-12.2,2.39c-1.25.25-2.15,1.34-2.15,2.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.97f922d65d3ee26c40b00ed49b1665e9.svg";
export { ForwardRef as ReactComponent };